export default __webpack_public_path__ + "static/media/info.2084271e.svg";